import { createSlice, isAllOf } from '@reduxjs/toolkit';
import { addToWishlistThunk, fetchGoogleAuthUrlThunk, fetchUserThunk, forgotPasswordThunk, handleGoogleCallbackThunk, loginUserThunk, registerUserThunk, sendOtpThunk, verifyOtpThunk } from '../../thunks/thunks';
import { toast } from 'react-toastify';


const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user:null,
    personalinfo:null,
    isLoading: false,
    error: null,
    otpSent: false,
    isLoggedIn: !!localStorage.getItem('authToken'),
    success:false
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      localStorage.removeItem('authToken');
      setIsLoggedIn(false);
    },
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
  },
  extraReducers:(builder)=>{
    builder
      .addCase(sendOtpThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(sendOtpThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.otpSent = true;
      })
      .addCase(sendOtpThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(registerUserThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(registerUserThunk.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(registerUserThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(loginUserThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUserThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
        state.isLoggedIn = true;
      })
      .addCase(loginUserThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(verifyOtpThunk.pending, (state) => {
        state.isLoading = true;
        state.message = '';
        state.error = '';
        state.otpStatus = null;
      })
      .addCase(verifyOtpThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.otpStatus = 'verified';
        state.message = action.payload.message;
        state.error = '';
      })
      .addCase(verifyOtpThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.otpStatus = 'failed';
        state.message = '';
        state.error = action.payload;
      })
      .addCase(addToWishlistThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      }
      )
      .addCase(addToWishlistThunk.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(addToWishlistThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchGoogleAuthUrlThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchGoogleAuthUrlThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchGoogleAuthUrlThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(handleGoogleCallbackThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(handleGoogleCallbackThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLoggedIn = true;
        state.user = action.payload;
      })
      .addCase(handleGoogleCallbackThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchUserThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      }
      )
      .addCase(fetchUserThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.personalinfo = action.payload;
      })
      .addCase(forgotPasswordThunk.pending, (state) => {
        state.isLoading = true;
        state.success = null;
        state.error = null;
      })
      .addCase(forgotPasswordThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(forgotPasswordThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

export const {setIsLoggedIn,logout} = authSlice.actions;
export default authSlice.reducer;
